import { hot } from 'react-hot-loader/root';
import React from 'react';
import PropTypes from 'prop-types';

import PageWrapper from '../design-system/PageWrapper';
import IconPageSection from '../design-system/IconPageSection';
import Container from '../design-system/Containers';
import { HeadingDossier } from '../design-system/Headings';
import Paragraph from '../design-system/Paragraph';
import { LinkButton } from '../design-system/Buttons';

const PrintOrderSuccessPage = ({
  phrases,
  dashboardPath,
}) => (
  <PageWrapper tallNav bgDark>
    <IconPageSection>
      <Container dossier>
        <HeadingDossier dark ttNone el="h1">{phrases.title}</HeadingDossier>
        <Paragraph dossierIntroHeavy dark>{phrases.subtitle}</Paragraph>
        <br />
        <LinkButton dossierPrimary href={dashboardPath}>{phrases.buttonLabel}</LinkButton>
      </Container>
    </IconPageSection>
  </PageWrapper>
);

PrintOrderSuccessPage.propTypes = {
  dashboardPath: PropTypes.string.isRequired,
  phrases: PropTypes.exact({
    buttonLabel: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }).isRequired,
};

export default hot(PrintOrderSuccessPage);
